import { useIntl } from 'react-intl';

import { StyledModal } from 'common/components';
import CreateProductForm from './CreateProductForm';
import CreateProductModalFooter from './CreateProductModalFooter';

import { useDispatchReloadPage } from 'hooks/useReloadPage';
// import { useGetProductFullView } from 'common/queries/product-module';

import useCreateProduct from 'hooks/createProductHooks';
import {
  useGetProductFullView,
  useGlobalModal,
  useGetProductOriginFullViewForProductOverlay,
} from 'hooks';
import {
  IXONECertificationWrapper,
  TYPE_VIEW,
} from 'common/components/product-add/IXONECertificationWrapper';

import messages from 'i18n/messages/product';

import './CreateProductViaFormModal.less';

function CreateProductViaFormModal({ isEdit, memberId, productId }) {
  const intl = useIntl();
  const reloadPage = useDispatchReloadPage();

  const { closeModal, checkModalVisible, MODAL_NAMES } = useGlobalModal();
  const isAddEditModalOpen = checkModalVisible(
    MODAL_NAMES.ADD_EDIT_PRODUCT_MODAL
  );

  const handleCancel = () => {
    resetFormState();
    closeModal(MODAL_NAMES.ADD_EDIT_PRODUCT_MODAL);
  };

  const { productFull, invalidateAllProductFull } = useGetProductFullView({
    productId,
    enabled: !!productId,
  });

  const { data: originProductFull, invalidAllProductOriginFull } =
    useGetProductOriginFullViewForProductOverlay({
      productOverlayId: productId,
      enabled: Boolean(productId && productFull?.isOverlayProduct),
    });

  const {
    form,
    submitForm,
    formLoading,
    resetFormState,
    ...createProductFormProps
  } = useCreateProduct({
    modalVisible: isAddEditModalOpen,
    productDetail: productFull,
    isEdit,
    reloadPage,
    callApiCallback: handleCancel,
    memberId: memberId,
    productId,
    invalidateAllProductFull,
    invalidAllProductOriginFull,
  });

  const modalProps = {
    title: isEdit
      ? intl.formatMessage(messages.editProduct)
      : intl.formatMessage(messages.addProduct),
    visible: isAddEditModalOpen,
    width: '85%',
    closable: true,
    maskClosable: false,
    onCancel: handleCancel,
    wrapClassName: 'add-edit-product-modal',
  };

  return (
    <div>
      <IXONECertificationWrapper
        showModal={isEdit}
        type={TYPE_VIEW.EDIT_PRODUCT}
        onConfirm={(ixoneIgnore, fieldList) => {
          submitForm(ixoneIgnore, fieldList);
        }}
        onCancel={handleCancel}
      >
        {(handleConfirmIXONE) => (
          <StyledModal
            {...modalProps}
            isLoading={formLoading}
            loadingContent={{ loadingText: 'Loading' }}
            centered
            footer={
              <CreateProductModalFooter
                onCancel={handleCancel}
                onOk={async () => {
                  const brickCode = createProductFormProps?.brick;
                  const formValue = await form.validateFields();
                  handleConfirmIXONE({
                    originalData: productFull,
                    changedFields: { ...formValue, ...brickCode },
                  });
                }}
                okLoading={formLoading}
                disabledOkButton={false}
              />
            }
          >
            <CreateProductForm
              form={form}
              memberIdBrand={memberId}
              originProductFull={originProductFull}
              productFull={productFull}
              {...createProductFormProps}
            />
          </StyledModal>
        )}
      </IXONECertificationWrapper>
    </div>
  );
}

export default CreateProductViaFormModal;
